jQuery(document).ready(function($) {
  var cs = document.getElementById("canvas");

  if (cs) {
    var w = $(".js-canvas").width();
    var h = $(".js-canvas").height();
    $("#canvas").attr("width", w);
    $("#canvas").attr("height", h);

    var ctx = cs.getContext("2d"),
      csWidth = cs.width,
      csHeight = cs.height,
      center = {
        x: csWidth / 100,
        y: csHeight / 100
      };

    // 線の基本スタイル
    ctx.strokeStyle = "#c30d23";
    ctx.lineWidth = 1;

    var drawVerticalLineAnim = function() {
      var beginPos = 100,
        movePos = beginPos,
        addVal = 20,
        endPos = csHeight - 100,
        isAnim = function() {
          return movePos < endPos;
        };

      var render = function() {
        ctx.beginPath();
        ctx.moveTo(center.x, beginPos);
        ctx.lineTo(center.x, movePos);
        ctx.closePath();
        ctx.stroke();

        // 描画を繰り返す条件
        if (isAnim() === true) {
          movePos += addVal;
          // ↑のaddで終了点を超えることがあるため上限を決める
          movePos = isAnim() === false ? endPos : movePos;
          requestAnimationFrame(render);
        }
      };
      render();
    };

    var drawHorizontalLineAnim = function() {
      var beginPos = 10, // スタート位置
        movePos = beginPos, // 移動位置（現在位置）
        addVal = 20, // 加算量
        endPos = csWidth - 10, // 終了位置
        isAnim = function() {
          // アニメーションを終了する条件
          return movePos < endPos;
        };

      var render = function() {
        ctx.beginPath();
        ctx.moveTo(beginPos, center.y);
        ctx.lineTo(movePos, center.y);
        ctx.closePath();
        ctx.stroke();

        if (isAnim() === true) {
          movePos += addVal;
          // ↑のaddで終了点を超えることがあるため上限を決める
          movePos = isAnim() === false ? endPos : movePos;
          requestAnimationFrame(render);
        }
      };
      render();
    };
    drawHorizontalLineAnim();
    drawVerticalLineAnim();
  }
});
